import type { MouseEvent } from 'react';

/**
 * A button that's busy (sharing, joining, saving) stays focusable: it says so with
 * `aria-disabled` and `aria-busy` instead of `disabled`, which would throw a keyboard or
 * screen-reader user's focus to <body> the moment they pressed it (A11Y-6, UX-019). It looks
 * disabled (base.css, buttons.css), and a press while busy does nothing.
 *
 *   <button type="button" className="btn md primary" {...busyButton(busy, share)}>Share</button>
 */
export function busyButton<E extends HTMLElement = HTMLButtonElement>(
	busy: boolean,
	onClick: (e: MouseEvent<E>) => void,
): { onClick: (e: MouseEvent<E>) => void; 'aria-disabled': true | undefined; 'aria-busy': true | undefined } {
	return {
		onClick: (e) => {
			if (busy) {
				e.preventDefault();
				return;
			}
			onClick(e);
		},
		'aria-disabled': busy ? true : undefined,
		'aria-busy': busy ? true : undefined,
	};
}
